import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { solicitudesApi } from "@/features/solicitudes/services/solicitudes.api";

/**
 * Listado PAGINADO de "mis solicitudes" · polling cada 5s para reflejar cambios
 * de estado mientras el usuario tiene la lista abierta (avances de
 * autorización, rechazos…).
 *
 * Los filtros de columna, el orden y la página van al server como query params
 * y forman parte del queryKey (refetch al cambiar). Usamos `useQuery` +
 * `keepPreviousData` para que, al cambiar el filtro/página, NO parpadee: se
 * mantienen las filas previas mientras llega el set nuevo.
 */
export const misSolicitudesQueryOptions = (params: Record<string, string | number | boolean> = {}) =>
  queryOptions({
    queryKey: [...qk.misSolicitudes, params] as const,
    queryFn: () => solicitudesApi.listarMias(params),
    refetchInterval: 5_000,
    staleTime: 0,
    placeholderData: keepPreviousData,
  });

export function useMisSolicitudes(params: Record<string, string | number | boolean> = {}) {
  return useQuery(misSolicitudesQueryOptions(params));
}
